export default {
  dialogTitle: "Batch Add to Dashboard",
  tradingBoard: {
    title: "Trading Data Dashboard",
    info: "View in trading data after adding",
  },
  balanceBoard: {
    title: "Balance Data Dashboard",
    info: "View in balance data after adding",
  },
  addBoth: {
    title: "Add to Both",
    info: "Add to both balance and trading dashboards",
  },
};
